import React, {useState, useRef, useEffect, useContext} from 'react';
import Image from 'next/image'
import {AiOutlineShopping} from 'react-icons/ai'
import {HiMenu} from 'react-icons/hi';
import { IoMdAdd, IoMdSearch } from 'react-icons/io';
import { useRouter } from 'next/router'
import {Cart, Sidebar, Field, Modal, ProfileMenu, UserIcon, CustomerLogo } from './';
import useNetworkStatus from '../hooks/useNetworkStatus'
import useNetwork from '../hooks/useNetwork';
import {VisDiv} from './';
import { clientUser } from '../lib/userPermissions';
import { useAuthContext } from '../hooks/useAuthContext';




//import {Sidebar} from './';
import {useStateContext} from '../context/StateContext';


const Navbar = () => {
    const {sUser, modalOpen, setIndexPage, setModalOpen, modalContent, setModalContent, showCart, setShowCart, totalQuantities, customer, searchTerm, setSearchTerm} = useStateContext();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const { user } = useAuthContext()
    const router = useRouter()

    const networkStatus = useNetworkStatus()

    const STATUS_BAR = () => {

        if(!networkStatus) {
            return(
                <div className='offline-bar'> 
                MODALITA' OFFLINE</div>
            )
        }
    }

    const toSearchPage = () =>{

        router.push(
            {
                pathname: '/Search',
                query: { keyword: searchTerm },
            }
          )

    }
    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };
    

    return (
        <>
       { modalOpen && <Modal
        setOpenModal={setModalOpen}
        modalContent={modalContent}
        /> }
        {STATUS_BAR()}
        <div className="navbar-container">
        <div className='navbar-left'>
        <VisDiv rules={[sUser, sUser?.language !== "en",]}>
            <HiMenu
                fontSize={40}
                className="mobile-menu-icon"
                onClick={openSidebar}
            />
            <Sidebar 
                isOpen={isSidebarOpen}
                onClose={closeSidebar}
                sUser={sUser}
                customer={customer}
            />
        </VisDiv>
  
        </div>
            <div className="logo">
                    <a onClick={()=>setIndexPage("HOME")}>
                        <CustomerLogo/>
                    </a>
            </div>
            <div className='navbar-right'>
                <VisDiv rules={[]}>
                    <ProfileMenu customer={sUser}/>
                </VisDiv>
             
                <VisDiv rules={[false]}>
                    <button type="button" className="cart-icon" onClick={() => setShowCart(true)}>
                        <AiOutlineShopping/>
                        <span className="cart-item-qty">{totalQuantities}</span>
                    </button>
                </VisDiv>

                {showCart && <Cart/>}
            </div>
            
            
        </div>

       <VisDiv rules={[false, user]}>
        {user && <Field
        value={searchTerm} 
        setValue={setSearchTerm}
        placeholder="Cerca"
        searchIcon="true"
        onFocus={toSearchPage}
         />}
        </VisDiv>

        </>
    )
}

export default Navbar

/*

        <div className="field-wrapper">
            <div className="field-icon">
          <IoMdSearch fontSize={21} className="searchIcon" />
          </div>
          <input
            type="text"
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Cerca"
            value={searchTerm}
            onFocus={() => toSearch() }
            className="field-ok"
            style={{backgroundImage:  <IoMdSearch fontSize={21} className="searchIcon" />}}
            
          />
         
        </div>


*/
